exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".single-review{display:flex;flex-direction:row}.single-review .hr-review-icon{flex-shrink:0}.single-review .hr-review-icon>img{width:4rem;height:4rem}.single-review .recommended{color:#235c9e;font-weight:bold}.single-review .review{width:100%}.single-review .review:nth-child(2){margin-left:1.5rem}.single-review .review p{margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/SingleReview.scss
// module id = 105
// module chunks = 0 1 2 3